module.exports = __webpack_public_path__ + "static/media/TP.d5ce26fb.png";